<template>
  <!--
  [ 스티키 클로즈 옵션 :  ]
  * x 버튼 영역이 스크롤시 고정됩니다.
  .sticky--header 

  [ 퀵메뉴 옵션 : hidden ]
  .view--quick-menu
  .view--user-menu

  [ 클로즈 버튼 보더 :  ]
  .style--close-border 
-->
  <div class="modal-menu OPTION view--quick-menu view--user-menu">
    <div class="modal-menu__head">
      <form-button
        class="icon--btn btn--lg icon--md"
        icon="close"
        type="button"
        @click="$emit('close')"
      ></form-button>
      <div class="btn--group">
        <a
          v-if="user.level >= $utils.getLevel('master1') && !isAdminMode"
          @click="$router.push({name: 'adminMain'})"
          class="menu__head--link"
        >
          <i class="material-icons">launch</i>
          <span class="head-menu__label">Admin</span>
        </a>
        <a
          @click="$router.push({name: 'mypage'})"
          v-if="user.role"
          class="menu__head--link"
        >
          <i class="material-icons">person_outline</i>
          <span class="head-menu__label">Mypage</span>
        </a>
        <a
          v-if="!user.role"
          @click="$router.push({name: 'login'})"
          class="menu__head--link"
        >
          <i class="material-icons">lock_open</i>
          <span class="head-menu__label">Login</span>
        </a>
        <a
          v-if="user.level >= $utils.getLevel('master1') && isAdminMode"
          @click="$router.push({name: 'home'})"
          class="menu__head--link"
        >
          <i class="material-icons">launch</i>
          <span class="head-menu__label">Home</span>
        </a>

        <a
          v-if="user.role"
          @click="logout"
          class="menu__head--link"
        >
          <i class="material-icons">lock_open</i>
          <span class="head-menu__label">Logout</span>
        </a>

      </div>
    </div>

    <div class="modal-menu__body">
      <div class="modal-menu__user-menu">
        <div class="quick-menu clearfix">
          <a
            class="quick-menu--link"
            @click="$router.push({name: 'boardList', params: {boardId: 'notice'}})"
          >
            <i class="material-icons">notifications_none</i>
            <span class="quick-menu__label">공지사항</span>
          </a>

          <!-- <a
            @click="$router.push({name: 'designView', params: {boardId: 'design', key: 'test'}})"
            class="quick-menu--link"
          >
            <i class="material-icons">date_range</i>
            <span class="quick-menu__label">오시는길</span>
          </a> -->

          <a
            @click="kakaoClick"
            class="quick-menu--link"
          >
            <i class="material-icons">chat_bubble_outline</i>
            <span class="quick-menu__label">카톡상담</span>
          </a>
          <a
            @click="$router.push({name: 'boardList', params: {boardId: 'qna'}})"
            class="quick-menu--link"
          >
            <i class="material-icons">forum</i>
            <span class="quick-menu__label">온라인상담</span>
          </a>

        </div>
      </div>
      <menu-main
        class="accordion spacing--lg"
        :menus="myMenu"
        :menuClick="menuClick"
        v-click-outside="menuOff"
      >
      </menu-main>
    </div>
  </div>
</template>

<script>
import menu from '../js/menu'
import theme from '@/component/js/theme'
import { mapState } from 'vuex'

export default {
  mixins: [menu, theme],
  computed: {
    ...mapState(['user', 'banners']),
    kakaoQuick () {
      const q = this.banners.quick.filter(menu => {
        return menu.title === 'quick2'
      })
      return q.length > 0 ? q[0] : ''
    }
  },
  methods: {
    async logout () {
      try {
        await this.$http.post('/api/auth/logout')
      } finally {
        this.$store.commit('SET_USER_INFO', {})
        this.$router.push({ name: 'home' })
      }
    },
    kakaoClick () {
      console.log(this.kakaoQuick)
      if (this.kakaoQuick.newWindowFlag === 'Y') {
        window.open(this.kakaoQuick.link, '_blank')
      } else {
        location.href = this.kakaoQuick.link
      }
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    MenuMain: () => import('@/component/layout/header/common/MenuMain')
  }
}
</script>
